import {Component, ElementRef, EventEmitter, HostBinding, OnDestroy, OnInit, Output, Renderer2} from '@angular/core';
import {GlobalEventService} from '../../services/global-event/global-event.service';
import {clickOutsideLinkMixin} from '../../mixin/click-outside.mixin';

@Component({
  selector: 'app-example-help-popup',
  templateUrl: './example-help-popup.component.html',
  styleUrls: ['./example-help-popup.component.scss']
})
export class ExampleHelpPopupComponent extends clickOutsideLinkMixin implements OnInit, OnDestroy {
  @HostBinding('class') class = 'help-contents-box';
  @Output() close = new EventEmitter<void>();

  constructor(
    public override elementRef: ElementRef,
    public override renderer: Renderer2,
    public override globalEventSvc: GlobalEventService,
  ) {
    super(elementRef, renderer, globalEventSvc);
  }

  ngOnInit() {
    this.coInit((event: MouseEvent | TouchEvent) => {
      if (!this.elementRef.nativeElement.parentNode.contains(event.target)) {
        this.close.emit();
      }
    });
  }

  ngOnDestroy() {
    this.coDestroy();
  }

  onClose(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.globalEventSvc.Click(event);

    this.close.emit();
  }
}
